import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Checkbox } from 'components/elements';
import { useQuery } from '@apollo/react-hooks';
import { useMutation } from 'components/graphql';
import { cloneDeep, debounce } from 'lodash';

import listCompareFa_Assortment from '../qql/listCompareFa_Assortment';
import changeCompareFa_Assortment from '../qql/changeCompareFa_Assortment';

export default (props) => {
  console.log(props.linkId);
  const { data, loading, client } = useQuery(listCompareFa_Assortment, { variables: { id: +props.linkId }, fetchPolicy: 'cache-and-network' });
  const [MUTATION_changeCompareFa_Assortment] = useMutation(changeCompareFa_Assortment);

  const mutationCheckbox = () =>{
    const values = client.readQuery({
      query: listCompareFa_Assortment,
      variables: {
        id: +props.linkId,
      },
    }).fakturaAssist.listCompareFa_Assortment;

    const arrId = [];

    for(const item of values) {
      item.open && arrId.push(item.id);
    }

    MUTATION_changeCompareFa_Assortment({ variables: {
      customerId: +props.linkId, arrId: arrId,
    } });
  };

  const debouncedMutationCheckbox = useCallback(debounce(mutationCheckbox, 2000, {
    leading: false,
    trailing: true,
  }), [props.linkId]);

  const set = (index, value) =>{
    const info = client.readQuery({
      query: listCompareFa_Assortment,
      variables: {
        id: +props.linkId,
      },
    }).fakturaAssist.listCompareFa_Assortment;

    const clone = cloneDeep(info);
    // debouncedMutationCheckbox.cancel();
    clone[index].open = value;

    client.writeQuery({
      query: listCompareFa_Assortment,
      variables: {
        id: +props.linkId,
      },
      data: {
        fakturaAssist: {
          listCompareFa_Assortment: clone,
          __typename: 'FA_Query',
        },
      },
    });
  };

  return (
    <Main>
      {!loading && data?.fakturaAssist?.listCompareFa_Assortment?.map((item, index) => {
        return(
          <Element onClick = {()=>{
            set(index, !data.fakturaAssist.listCompareFa_Assortment[index].open);
            //debouncedMutationCheckbox.cancel();
            debouncedMutationCheckbox();
          }}>
            <Checkbox
              withoutFormik
              key={data.fakturaAssist.listCompareFa_Assortment[index].id}
              width='100%'
              margin='20px 0 0 0'
              onChange={() => {}}
              value={data?.fakturaAssist?.listCompareFa_Assortment.every((i) => !!!i.open) ? true : data.fakturaAssist.listCompareFa_Assortment[index].open}
              name={`[${index}]open`}
              title={data.fakturaAssist.listCompareFa_Assortment[index].name}
            />
          </Element>
        );
      })}
    </Main>
  );
};

const Main = styled.div`
  width: 900px;
  display: block;
 height: auto;
`;

const Element = styled.div`
  padding-top: -20px;
  width: 33.3%;
  float: left;
  height: 40px;
`;
